// Caches how many dependency rows a given factsheet has, keyed per
// application, so the factsheet page's loading skeleton renders the
// Dependencies table at close to its real row count on repeat visits instead
// of a generic placeholder.
//
// Thin, page-specific wrapper around the generic cache — see
// composables/useSkeletonCountCache.js and docs/skeleton_count_caching.md.
import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const DEFAULT_COUNT = 2
const MAX_COUNT = 10

export function getCachedItComponentDependenciesCount(applicationId) {
  return Math.min(getCachedSkeletonCount(`factsheet_dependencies_it:${applicationId}`, DEFAULT_COUNT), MAX_COUNT)
}

export function setCachedItComponentDependenciesCount(applicationId, count) {
  setCachedSkeletonCount(`factsheet_dependencies_it:${applicationId}`, count)
}
